import React from "react";
import { motion } from "framer-motion";
import "./commonBlock.css";
import { headers, contentProfit, contentStek, partners } from "../data";
import Projects from "./projects";
import TableEco from "./tableEco";
import PartnerBox from "./partnerBox";
import BtnLink from "../btns/BtnLink";

export default function CommonBlock() {
  return (
    <div className="commonBlock">
      {/* Первый блок */}
      <div className="headersBlock">
        <h2>{headers[0].header}</h2>
      </div>
      <div className="contentBlock">
        {contentProfit.slice(0, 4).map((card) => (
          <motion.div
            initial={{ scale: 1 }}
            whileHover={{
              y: -5,
              scale: 1.02,
              boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
              transition: { duration: 0.2 },
            }}
            whileTap={{
              y: 2,
              boxShadow: "0px 1px 2px rgba(0,0,0,0.2)",
              transition: { duration: 0.1 },
            }}
            key={card.id}
            className="contentBox"
          >
            <img src={card.src} alt="icon" />
            <p>{card.description}</p>
          </motion.div>
        ))}
      </div>
      {/* Второй блок */}
      <div className="headersBlock">
        <h2>{headers[1].header}</h2>
      </div>
      <div className="contentBlock">
        {contentStek.slice(0, 5).map((card2) => (
          <motion.div
            initial={{ scale: 1 }}
            whileHover={{
              y: -5,
              scale: 1.02,
              boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
              transition: { duration: 0.2 },
            }}
            whileTap={{
              y: 2,
              boxShadow: "0px 1px 2px rgba(0,0,0,0.2)",
              transition: { duration: 0.1 },
            }}
            key={card2.id}
            className="contentBox2"
          >
            <h3 className="gradientText">{card2.title}</h3>
            <p>{card2.description}</p>
          </motion.div>
        ))}
      </div>
      <div className="contentBlock"></div>
      {/* Третий блок */}
      <div className="headersBlock">
        <h2>{headers[6].header}</h2>
        <BtnLink src="/cases" width="medium-low">
          Смотреть все
        </BtnLink>
      </div>
      <div className="contentBlock">
        <Projects />
      </div>
      {/* Четвертый блок */}
      <div className="headersBlock">
        <h2>{headers[2].header}</h2>
      </div>
      <div className="contentBlock partnerBlock">
        {partners.map((img) => (
          <PartnerBox imgObj={img} />
        ))}
      </div>
      {/* Четвертый блок */}
      <TableEco />
    </div>
  );
}
